import script from "./LoadUsersMixin.vue?vue&type=script&lang=js"
export * from "./LoadUsersMixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__